module.exports = __webpack_public_path__ + "static/img/sem-imagem.44e3842.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sem-imagem.png
// module id = 7sUr
// module chunks = 1